import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'international-language_selector_language_click-click';

/**
 * Language selector on click event tracking.
 */
export function trackInternationalLanguageSelectorLanguageClickClick(
  Display_type: string,
  Language_selector_location2: string,
  Language_selected3: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: {
      Display_type,
      Language_selector_location2,
      Language_selected3,
    },
  });
}
